








































































































































































































































































































































import { Component } from 'vue-property-decorator';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import ProductType from '@/models/Products/ProductType';
import ProductSubType from '@/models/Products/ProductSubType';
import { ProductWizardModule } from '@/store/Products/ProductWizardModule';
import GeneralProductSettingsEdit from '@/components/Products/Forms/Shared/GeneralProductSettingsEdit.vue';
import DepositPaymentOrderSettingsEdit from '@/components/Products/Forms/Deposit/DepositPaymentOrderSettingsEdit.vue';
import GeneralPayeeSettingsEdit from '@/components/Products/Forms/Shared/GeneralPayeeSettingsEdit.vue';
import DepositInterestSettingsEdit from '@/components/Products/Forms/Deposit/DepositInterestSettingsEdit.vue';
import DepositBankSettingsEdit from '@/components/Products/Forms/Deposit/DepositBankSettingsEdit.vue';
import DepositCardSettingsEdit from '@/components/Products/Forms/Deposit/DepositCardSettingsEdit.vue';
import DepositOverdraftSettingsEdit from '@/components/Products/Forms/Deposit/DepositOverdraftSettingsEdit.vue';
import DepositOverdraftInterestSettingsEdit from '@/components/Products/Forms/Deposit/DepositOverdraftInterestSettingsEdit.vue';
import DepositInstantAccessSettingsEdit from '@/components/Products/Forms/Deposit/DepositInstantAccessSettingsEdit.vue';
import DepositCoolingOffSettingsEdit from '@/components/Products/Forms/Deposit/DepositCoolingOffSettingsEdit.vue';
import GeneralLedgerSettingsEdit from '@/components/Products/Forms/Shared/GeneralLedgerSettingsEdit.vue';
import PageNames from '@/router/PageNames';
import { AppModule } from '@/store/Auth/AppModule';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'DepositNoticeAccountWizard', components: {
    Alert,
    GeneralProductSettingsEdit,
    DepositPaymentOrderSettingsEdit,
    GeneralPayeeSettingsEdit,
    DepositBankSettingsEdit,
    DepositCardSettingsEdit,
    DepositOverdraftSettingsEdit,
    DepositOverdraftInterestSettingsEdit,
    DepositInterestSettingsEdit,
    DepositInstantAccessSettingsEdit,
    DepositCoolingOffSettingsEdit,
    GeneralLedgerSettingsEdit
} })
export default class extends SaascadaVue {

    currentStep: number = 1;
    ProductSubType = ProductSubType;
    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;

    async beforeMount() {
        await ProductWizardModule.getRateSources();
    }

    get nextButtonName() {
        if (PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.ProductBankSettings)) {
            return (this.currentStep === 8) ? this.$t('pageText.productWizard.buttons.create') : this.$t('pageText.productWizard.buttons.next');
        }
        else {
            return (this.currentStep === 7) ? this.$t('pageText.productWizard.buttons.create') : this.$t('pageText.productWizard.buttons.next');
        }
    }

    get step() {
        return this.currentStep;
    }

    set step(value) {
        if (this.currentStep != value) {
            this.currentStep = value;
        }
    }

    get productId() {
        return ProductWizardModule.createProductViewModel.newProductId;
    }

    get errorMessage(){
        return AppModule.lastError == null? "" : AppModule.lastError.message;
    }

    async createProduct() {
        // Set the type and sub type on the view model then create the product
        this.productVM.generalSettings.type = ProductType.Deposit;
        this.productVM.generalSettings.subType = ProductSubType.DepositNoticeAccount;
        await ProductWizardModule.createProduct();
    }

    async navigateToProduct() {
        this.$router.push({ name: PageNames.Product, params: { id: ProductWizardModule.createProductViewModel.newProductId } });
    }

    async refreshPage() {
        this.$router.go(0);
    }

    async backClick() {
        this.step -= 1
    }

    async nextClick() {
        if (PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.ProductBankSettings)) {
            switch (this.currentStep) {
                case 1: {
                    if (!(this.$refs.productGeneralDetailsEdit as any).validateForm()) {
                        return;
                    }
                    this.step += 1;
                    break;
                }
                case 2: {
                    if (!(this.$refs.generalPayeeSettingsEdit as any).validateForm()) {
                        return;
                    }
                    this.step += 1;
                    break;
                }
                case 3: {
                    if (!(this.$refs.depositPaymentOrderSettingsEdit as any).validateForm()) {
                        return;
                    }
                    this.step += 1;
                    break;
                }
                case 4: {
                    if (!(this.$refs.depositBankSettingsEdit as any).validateForm()) {
                        return;
                    }
                    this.step += 1;
                    break;
                }
                case 5: {
                    if (!(this.$refs.depositInterestSettingsEdit as any).validateForm()) {
                        return;
                    }
                    this.step += 1;
                    break;
                }
                case 6: {
                    if (!(this.$refs.depositInstantAccessSettingsEdit as any).validateForm()) {
                        return;
                    }
                    this.step += 1;
                    break;
                }
                case 7: {
                    if (!(this.$refs.depositCoolingOffSettingsEdit as any).validateForm()) {
                        return;
                    }
                    this.step += 1;
                    break;
                }
                case 8: {
                    if (!(this.$refs.generalLedgerSettingsEdit as any).validateForm()) {
                        return;
                    }
                    this.step += 1;
                    await this.createProduct();
                    break;
                }
            }
        }
        else {
            switch (this.currentStep) {
                case 1: {
                    if (!(this.$refs.productGeneralDetailsEdit as any).validateForm()) {
                        return;
                    }
                    this.step += 1;
                    break;
                }
                case 2: {
                    if (!(this.$refs.generalPayeeSettingsEdit as any).validateForm()) {
                        return;
                    }
                    this.step += 1;
                    break;
                }
                case 3: {
                    if (!(this.$refs.depositPaymentOrderSettingsEdit as any).validateForm()) {
                        return;
                    }
                    this.step += 1;
                    break;
                }
                case 4: {
                    if (!(this.$refs.depositInterestSettingsEdit as any).validateForm()) {
                        return;
                    }
                    this.step += 1;
                    break;
                }
                case 5: {
                    if (!(this.$refs.depositInstantAccessSettingsEdit as any).validateForm()) {
                        return;
                    }
                    this.step += 1;
                    break;
                }
                case 6: {
                    if (!(this.$refs.depositCoolingOffSettingsEdit as any).validateForm()) {
                        return;
                    }
                    this.step += 1;
                    break;
                }
                case 7: {
                    if (!(this.$refs.generalLedgerSettingsEdit as any).validateForm()) {
                        return;
                    }
                    this.step += 1;
                    await this.createProduct();
                    break;
                }
            }
        }
    }

    get productVM() {
        return ProductWizardModule.createProductViewModel;
    }

    get loading() {
        return ProductWizardModule.loadingWizard;
    }

}
